<form [formGroup]="targetForm">
    <header class="info-tile-alt heading-row">
        <div class="title-container">
            <h2>Add Client User</h2>
        </div>
        <div class="drawer-close" (click)="rightSideDrawerService.closeRightSideDrawer()"><i class="fas fa-times" aria-hidden="true"></i></div>
    </header>
    <section class="sideRight-body">
        <label for="ei-name">
                Sign-in Name*
            <span *ngIf="f.signinname.errors && (f.signinname.touched || f.signinname.dirty)">
                <span class="required-error" *ngIf="f.signinname.errors.required">(required)</span>
                <span class="required-error" *ngIf="f.signinname.hasError('pattern')">Sign-in name must be in a valid email address format.</span>
            </span>
            <input class="black-input opposite-colors" placeholder="Sign-in Name" type="text" no-special-chars="#!$%^<>+=" 
            formControlName="signinname" (blur)="checkSigninName('signinname')" (keyup)="UpdateEmail($event)"
            required/>
        </label>
        <div class="form-error-sign" *ngIf="IsSignInNameExists">
                <p>Sign-in name already exists.</p>
            </div>
        <label for="ei-displayName">
                Display Name*
                <span *ngIf="f.displayName.errors && (f.displayName.touched || f.displayName.dirty) && !isDisplayNameEntered">
                    <span class="required-error" *ngIf="f.displayName.errors.required">(required)</span>
                </span>
                <input class="black-input opposite-colors" placeholder="Display Name of User" type="text" no-special-chars="#!$%^<>+=" 
                (blur)="trimSpecialCharName('displayName');" formControlName="displayName" (input)="displayNameChange()"
                    required/>
        </label>            
        <label for="ei-email">
            Email*
            <span *ngIf="f.email.errors && (f.email.touched || f.email.dirty)">
                <span class="required-error" *ngIf="f.email.errors.required">(required)</span>
                <span class="required-error" *ngIf="f.email.hasError('pattern')">Email must be in a valid email address format.</span>
            </span>
            <input class="black-input opposite-colors" placeholder="Email" type="text" no-special-chars="#!$%^<>+="   formControlName="email" required>
        </label>
        <div class="form-error-sign" *ngIf="IsEmailExists">
            <p>Email address already exists.</p>
        </div>
        <!-- <div class="input-with-icon" *ngIf="isClient">
            Client Name*            
            <ng-container *ngIf="!isClientMode">
                <span *ngIf="(f.clientName.touched && !isClientSelected)">
                    <span class="required-error"> (required)</span>
                </span>
                <input class="black-input opposite-colors clients-autocomplete"
                    [ngClass]="{'ng-invalid' :  !isClientSelected }"
                    placeholder="Search Existing Clients or Enter Client Name" type="text" no-special-chars="#!$%^<>+="
                    [kpmgUiTypeahead]="searchExistingClients" [resultTemplate]="ct" [editable]="true"
                    [inputFormatter]="clientFormatter" 
                    (selectItem)="onClientSelected($event)" formControlName="clientName">

                <ng-template #ct let-c="result" let-t="term">
                    <kpmg-ui-highlight class="create-engagement-typeahead" [result]="c.clientName" [term]="t">
                    </kpmg-ui-highlight>&nbsp;
                </ng-template>
            </ng-container>
            <ng-container *ngIf="isClientMode">
                <span *ngIf="f.clientName.errors && (f.clientName.touched || f.clientName.dirty)">
                    <span class="required-error"> (required)</span>
                </span>
                <input  class="black-input opposite-colors"
                    [ngClass]="{'ng-invalid' :  (f.clientName.errors && (f.clientName.touched || f.clientName.dirty))}"
                    placeholder="Client Name" type="text" no-special-chars="#!$%^<>+=" [(ngModel)]="clientName"
                    formControlName="clientName" required />
            </ng-container>
        </div> -->


        
        <!-- <div *ngIf="!isClient" class="archive__toggle" style="padding-top: 10px;" >
            <span class="mr-4">Is a Contractor</span>          
                <label class=" mr-2 archive-checkbox" style="width: 40px;">
                        <toggle-switch (toggleState)="IsContractor()"></toggle-switch><span></span>
                </label>
        </div> -->

        <div class="additional-role">
                <h4 class="role-heading">Additional Roles</h4>
            <div class="archive__toggle" style="padding-top: 10px;" >
                <span class="mr-4">Client Manager</span>
                <label class=" mr-2 archive-checkbox" style="width: 40px;">
                    <toggle-switch (toggleState)="SetRoles(clientManager)"></toggle-switch><span></span>
                </label>            
            </div>


           
    </div>
        

    </section>
    <footer class="endFormSubmit info-tile">
        <button type='button' class="btn btn-success" (click)="postRightSideDrawerData()"
            [disabled]="!targetForm.valid || IsEmailExists || IsSignInNameExists || !isDisplayNameEntered">Add Client User</button>        
        <button class="btn kpmg-button--flat"
        (click)="rightSideDrawerService.closeRightSideDrawer();resetRightSideDrawerData()">Cancel</button>
    </footer>
</form>
